export default __webpack_public_path__ + "static/media/PAFI_The Invitation of GMS 30 Juni 2025.dc6ce070.pdf";